import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleQtvSimilarTitleFragmentDoc } from './GetSingleQTV.query';
import { TitleOfferFragmentDoc, FastOfferFragmentDoc } from '../fragments/Offer.fragment';
import { TrailerClipsFragmentDoc } from '../../../../pages/graphql/fragments/TrailerClips.fragment';
export type GetSingleQtvTargetedTitleQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	targetTitleId: Types.Scalars['ID']['input'];
	language: Types.Scalars['Language']['input'];
	offerFilters: Types.OfferFilter;
	withClips?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetSingleQtvTargetedTitleQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article'; id: string }
		| { __typename?: 'Author'; id: string }
		| { __typename?: 'Bundle'; id: string }
		| { __typename?: 'Device'; id: string }
		| { __typename?: 'Episode'; id: string }
		| { __typename?: 'GenericTitleList'; id: string }
		| { __typename?: 'Genre'; id: string }
		| { __typename?: 'HomePage'; id: string }
		| {
				__typename?: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offers: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						maskReferrer?: boolean | null;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				content: {
					__typename?: 'MovieContent';
					title: string;
					posterUrl?: string | null;
					fullPath: string;
					tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
						jwRating?: number | null;
					};
					interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
					genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
				};
		  }
		| { __typename?: 'MultiStepSportEvent'; id: string }
		| { __typename?: 'Offer'; id: string }
		| { __typename?: 'OfferHistory'; id: string }
		| { __typename?: 'Package'; id: string }
		| { __typename?: 'Page'; id: string }
		| { __typename?: 'Person'; id: string }
		| { __typename?: 'PressRelease'; id: string }
		| { __typename?: 'ProfileV2'; id: string }
		| { __typename?: 'Season'; id: string }
		| {
				__typename?: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offers: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					newElementCount?: number | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					userLocalCurrency?: string | null;
					retailPriceConverted?: string | null;
					currency?: string | null;
					lastChangeRetailPriceValue?: number | null;
					type: Types.OfferType;
					country: any;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					elementCount?: number | null;
					availableTo?: any | null;
					subtitleLanguages: Array<any>;
					videoTechnology: Array<Types.VideoTechnology>;
					audioTechnology: Array<Types.AudioTechnology>;
					audioLanguages: Array<any>;
					updatedAt?: any | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						icon: string;
						iconWide: string;
						maskReferrer?: boolean | null;
						planOffers: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					};
					plans: Array<{
						__typename?: 'PackagePlanOffer';
						title?: string | null;
						retailPrice?: string | null;
						isTrial?: boolean | null;
						durationDays?: number | null;
						retailPriceValue?: number | null;
						retailPriceConverted?: string | null;
						children: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
						}>;
					}>;
				}>;
				content: {
					__typename?: 'ShowContent';
					title: string;
					posterUrl?: string | null;
					fullPath: string;
					tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: {
						__typename?: 'Scoring';
						imdbVotes?: number | null;
						imdbScore?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
						jwRating?: number | null;
					};
					interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
					genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
				};
		  }
		| { __typename?: 'SingleStepSportEvent'; id: string }
		| { __typename?: 'SportCompetitionV2'; id: string }
		| { __typename?: 'SportCompetitorV2'; id: string }
		| { __typename?: 'SportMatch'; id: string }
		| { __typename?: 'Url'; id: string }
		| { __typename?: 'UserProviderSubscription'; id: string }
		| null;
};

export const GetSingleQtvTargetedTitleDocument = gql`
	query GetSingleQtvTargetedTitle(
		$country: Country!
		$targetTitleId: ID!
		$language: Language!
		$offerFilters: OfferFilter!
		$withClips: Boolean = false
	) {
		node(id: $targetTitleId) {
			id
			... on MovieOrShow {
				...SingleQtvSimilarTitle
				offers(country: $country, platform: WEB, filter: $offerFilters) {
					...TitleOffer
				}
				... on Movie {
					content(country: $country, language: $language) {
						clips(country: $country, language: "en", first: 4) @include(if: $withClips) {
							...TrailerClips
						}
						dailymotionClips: clips(providers: [DAILYMOTION], country: $country, language: "en", first: 4)
							@include(if: $withClips) {
							...TrailerClips
						}
					}
				}
				... on Show {
					content(country: $country, language: $language) {
						clips(country: $country, language: "en", first: 4) @include(if: $withClips) {
							...TrailerClips
						}
						dailymotionClips: clips(providers: [DAILYMOTION], country: $country, language: "en", first: 4)
							@include(if: $withClips) {
							...TrailerClips
						}
					}
				}
			}
		}
	}
	${SingleQtvSimilarTitleFragmentDoc}
	${TitleOfferFragmentDoc}
	${TrailerClipsFragmentDoc}
`;
